import React from "react";
import QuizContent from "../shared/QuizContent";
import QuizTitle from "../shared/QuizTitle";
import QuizOptions from "../shared/QuizOptions";
import QuizOption from "../shared/QuizOption";
import { getQuizOptions } from "../../utils/quizOptions";

const Step7 = ({ onAnswer }) => {
  const quizOptions = getQuizOptions("frustration");

  const handleOptionClick = (value) => {
    onAnswer("frustration", value);
  };

  return (
    <div className="quizContentWrapper">
      <QuizContent>
        <QuizTitle>
          What frustrates you most about the people around you?
        </QuizTitle>
        <QuizOptions>
          {quizOptions.map((option) => (
            <QuizOption
              key={option.value}
              value={option.value}
              name="frustration"
              onClick={handleOptionClick}
            >
              <div>
                <p>
                  <strong>{option.text}</strong>
                </p>
              </div>
            </QuizOption>
          ))}
        </QuizOptions>
      </QuizContent>
    </div>
  );
};

export default Step7;
